// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctm-color-preview-wrap[data-v-734d5bd8]{display:inline-flex;align-items:center;gap:8px;padding:4px 10px 4px 4px;border:1px solid #d1d5db;border-radius:6px;background:#fff;cursor:default}.ctm-color-input[data-v-734d5bd8]{width:32px;height:28px;border:none;border-radius:4px;padding:0;cursor:default;outline:none;background:none}.ctm-color-value[data-v-734d5bd8]{font-size:13px;color:#374151;font-family:monospace}", ""]);
// Exports
module.exports = exports;
